import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface EducationLevel {
  id?: string
  name: string
  code: string
  countryId: string
}

export async function getEntities(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['country_id = :countryId']
  if (search) {
    where.push(`CONCAT(name, code) ILIKE '%${search}%'`)
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          `ORDER BY (CASE WHEN code ~ '^[0-9]+$' THEN CAST(code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, code ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        "ORDER BY (CASE WHEN code ~ '^[0-9]+$' THEN CAST(code AS numeric) ELSE NULL END), code"
      ])

  // result
  const response: any = await getData({
    tables: ['pg_education_levels'],
    fields: ['id', 'name', 'code', 'updated_at'],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response[0]
}

export async function getEducationLevelModel(
  id: string
): Promise<EducationLevel> {
  const data = await getData<any>({
    tables: ['pg_education_levels'],
    fields: ['id', 'name', 'code', 'country_id', 'custom_fields as custom'],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createEducationLevel(
  data: EducationLevel
): Promise<boolean> {
  const response: any = await http.post('employee/education-levels', {
    countryId: data.countryId,
    name: data.name,
    code: data.code
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateEducationLevel(
  data: EducationLevel,
  id: string
): Promise<boolean> {
  const response: any = await http.put('employee/education-levels/' + id, {
    countryId: data.countryId,
    name: data.name,
    code: data.code
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteEducationLevel(id: string): Promise<boolean> {
  const response: any = await http.delete('employee/education-levels/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
